export const INVALID_SIGNUP_MSG =
  'There is already an account tied to this email. Please login to your account or change the email address to create a new account.';
